import PropTypes from 'prop-types'
import React from 'react'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconQuestion = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip,
  'data-for': dataFor,
  inline
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
      data-for={dataFor}
      inline={inline}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M12.000,24.000 C5.383,24.000 -0.000,18.617 -0.000,12.000 C-0.000,5.383 5.383,-0.000 12.000,-0.000 C18.617,-0.000 24.000,5.383 24.000,12.000 C24.000,18.617 18.617,24.000 12.000,24.000 ZM12.000,2.000 C6.486,2.000 2.000,6.486 2.000,12.000 C2.000,17.514 6.486,22.000 12.000,22.000 C17.514,22.000 22.000,17.514 22.000,12.000 C22.000,6.486 17.514,2.000 12.000,2.000 ZM14.389,12.344 C12.940,13.517 12.994,14.816 12.997,14.870 C13.028,15.415 12.616,15.892 12.072,15.932 C12.046,15.934 12.022,15.935 11.997,15.935 C11.484,15.935 11.050,15.551 11.004,15.032 C10.996,14.936 10.821,12.659 13.130,10.789 C13.772,10.270 14.000,9.814 14.000,9.051 C14.000,7.889 13.103,6.943 12.000,6.943 C10.860,6.943 10.000,7.803 10.000,8.943 C10.000,9.496 9.552,9.943 9.000,9.943 C8.448,9.943 8.000,9.496 8.000,8.943 C8.000,6.701 9.757,4.944 12.000,4.944 C14.206,4.944 16.000,6.786 16.000,9.051 C16.000,10.426 15.503,11.442 14.389,12.344 ZM12.165,16.986 C12.709,17.080 13.079,17.569 12.985,18.114 L12.976,18.170 C12.892,18.656 12.469,19.000 11.991,19.000 C11.935,19.000 11.878,18.995 11.820,18.985 C11.276,18.891 10.911,18.374 11.005,17.830 C11.099,17.286 11.618,16.891 12.165,16.986 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconQuestion.defaultProps = {
  inline: true
}

IconQuestion.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string,
  inline: PropTypes.bool,
  'data-for': PropTypes.string
}
